import React, { useEffect } from 'react';
import { Box, BoxProps } from '@hover/blueprint';
import { useIntersect } from '../../../hooks';

interface Props extends BoxProps {
  children: React.ReactNode;
  setSectionIntersect: (intersect: number) => void;
}

const buildThresholdArray = () => Array.from(Array(100).keys(), i => i / 100);

const IntersectBox: React.FC<Props> = ({
  setSectionIntersect,
  children,
  ...rest
}) => {
  const [ref, entry] = useIntersect({
    threshold: buildThresholdArray(),
  });

  useEffect(() => {
    if (entry) {
      setSectionIntersect(entry.intersectionRatio);
    }
  }, [entry]);

  return (
    // @ts-ignore
    <Box ref={ref} {...rest}>
      {children}
    </Box>
  );
};

export default IntersectBox;
